import { TermosListSearchComponent } from './TermosListSearchComponent'
import { TermosListToolbar } from './TermosListToolbar'

export const TermosListHeader = () => {
  return (
    <div className='card-header border-0 pt-6'>
      <TermosListSearchComponent actions={<TermosListToolbar />} />
    </div>
  )
}
